import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

export type MarqueeProps = {
    text: string;
};

export const Marquee = (props: MarqueeProps) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [textWidth, setTextWidth] = useState(0);

    useEffect(() => {
        if (textRef.current) {
            setTextWidth(textRef.current.offsetWidth);
        }
    }, [props.text]);

    return (
        <Box
            sx={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                position: 'relative',
                width: '100%',
                backgroundColor: '#f0f0f0',
                padding: '8px',
            }}
        >
            <Box
                component='span'
                sx={{
                    display: 'inline-block',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    textAlign: 'left',
                    animation: `marquee ${20 + textWidth / 100}s linear infinite`,
                    // backgroundColor: '#ff0000',
                }}
            >
                <span ref={textRef}>{props.text}</span>
            </Box>

            <style>
                {`
                @keyframes marquee {
                    0% { transform: translateX(100%); }
                    100% { transform: translateX(calc(0% - ${textWidth}px)); }
                }
                `}
            </style>
        </Box>
    );
};
